/* QUICK HELP (owner call 2026-09-19: "go through the entire frontend of app
   and wire up a description on hover"). The kit's Help seat opens a floating
   card that reads, off whatever the pointer is over, the NEAREST ancestor
   wearing data-qh-title / data-qh-body — so a broad note on a region and a
   precise one on a control inside it layer without fighting.

   This is the kit's own useQuickHelp shape, minus the `use` prefix: it is a
   pure attribute pair, called inside .map() and on plain DOM, and a hook's
   name on a non-hook only trips the lint. Spread it onto any element. */
export const qh = (title, body) => ({ 'data-qh-title': title, 'data-qh-body': body || '' })
